import initialState from './initialState';
import { reducer as getSystemCountReducer } from './getSystemCount';
import { reducer as getHotByPositionTypeReducer } from './getHotByPositionType';
import { reducer as getHotByAreaReducer } from './getHotByArea';
import { reducer as getCountByPositionTypeReducer } from './getCountByPositionType';
import { reducer as countByEduReducer } from './countByEdu';
import { reducer as countByAgeReducer } from './countByAge';
import { reducer as countByGenderReducer } from './countByGender';
import { reducer as getSendPositionActionReducer } from './getSendPositionAction';
import { reducer as getBrowerActionReducer } from './getBrowerAction';
import { reducer as getPositionBrowerActionReducer } from './getPositionBrowerAction';

const reducers = [
  getSystemCountReducer,
  getHotByPositionTypeReducer,
  getHotByAreaReducer,
  getCountByPositionTypeReducer,
  countByEduReducer,
  countByAgeReducer,
  countByGenderReducer,
  getSendPositionActionReducer,
  getBrowerActionReducer,
  getPositionBrowerActionReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  /* istanbul ignore next */
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/home/redux/reducer.js